import { render, staticRenderFns } from "./Jabatan.vue?vue&type=template&id=9a7bc476&"
import script from "./Jabatan.vue?vue&type=script&lang=js&"
export * from "./Jabatan.vue?vue&type=script&lang=js&"
import style0 from "./Jabatan.vue?vue&type=style&index=0&id=9a7bc476&prod&lang=css&"
import style1 from "./Jabatan.scss?vue&type=style&index=1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports